export default "__VITE_ASSET__f8788ebf__"